/**
 * loyalty-points-modal.js
 * Gère l'affichage des points fidélité et la modale sur les fiches produit.
 * Chargé une seule fois via defer dans loyalty-points-modal.liquid
 */

(function () {
  'use strict';

  function initLoyaltyModal(productId) {
    var modalId   = 'loyalty-modal-' + productId;
    var trigger   = document.querySelector('[aria-controls="' + modalId + '"]');
    var modal     = document.getElementById(modalId);
    if (!trigger || !modal) return;

    var backdrop  = modal.querySelector('.loyalty-modal__backdrop');
    var closeBtn  = modal.querySelector('.loyalty-modal__close');

    /* --- Modale --- */
    function openModal()  { modal.showModal(); document.body.style.overflow = 'hidden'; }
    function closeModal() { modal.close();     document.body.style.overflow = ''; }

    trigger.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    /* --- Mise à jour des points au changement de variant --- */
    function updatePoints(priceInCents) {
      var points = Math.floor(priceInCents / 100);
      document.querySelectorAll(
        '#loyalty-points-wrapper-' + productId + ' .loyalty-points__count, ' +
        '#' + modalId + ' .loyalty-modal__points-count'
      ).forEach(function (el) { el.textContent = points; });
    }

    // Écouter l'event natif Shopify de changement de variant
    document.addEventListener('variant:changed', function (e) {
      if (e.detail && e.detail.variant && String(e.detail.productId) === String(productId)) {
        updatePoints(e.detail.variant.price);
      }
    });

    // Fallback : écouter les changements sur le formulaire
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', function () {
        var variantData = window.__loyaltyVariants && window.__loyaltyVariants[productId];
        if (!variantData) return;
        var selected = form.querySelector('[name="id"]');
        if (!selected) return;
        var variant = variantData.find(function (v) { return String(v.id) === String(selected.value); });
        if (variant) updatePoints(variant.price);
      });
    }
  }

  // Initialiser tous les modals présents sur la page
  document.querySelectorAll('[data-loyalty-product-id]').forEach(function (el) {
    initLoyaltyModal(el.dataset.loyaltyProductId);
  });
})();
